(() => {
  const TARGET_CLASSES = [
    'custom-reta-glp-1-capsules™',
    'custom-suppressa-glp-1-shred-stack™',
    'custom-reta-glp-1-stack™',
    'custom-reta-glp-1-gummies™',
    'custom-the-glp-1-activation™',
    'custom-the-playboy-stack™',
    'custom-suppressa-shred-stack',
    'custom-the-invincible-stack™',
'custom-suppressa-shred-stack',
'custom-reta-gpl-1-stack',
'custom-reta-glp-1-gummies',
'custom-the-glp-1-activation-stack',
'custom-play-boy-stack',
'custom-the-invincible-stack',
'custom-reta-glp-1-stack'

  ];

  const ALL_PRODUCTS_TAGS = [];

  const SCAN_TAGS = ['jc-reta-product', 'jc-suppressa-product', 'jc-general-product', 'jc-playboy-product', 'jc-invincible-product'];

  const init = (root) => {
    if (root.dataset.onemonthInit === 'true') return;

    const subBlock = root.querySelector('[data-jc-purchase="subscription"]');
    const variantInput = root.querySelector('[data-jc-variant-input]');
    const planInput = root.querySelector('[data-jc-selling-plan-input]');
    const cards = Array.from(root.querySelectorAll('[data-jc-variant-card]'));
    if (!subBlock || !variantInput || !cards.length) return;

    const oneMonthCard = cards.find((card) =>
      /1\s*month/i.test(card.querySelector('.jc-product-variant-card__supply')?.textContent || '')
    );
    const oneMonthId = String(oneMonthCard?.getAttribute('data-jc-variant-card') || '');
    if (!oneMonthId) return;

    // Checks pass hone ke baad hi flag set karo (late render par dobara try ho sake)
    root.dataset.onemonthInit = 'true';

    // 1 Month card ke ANDAR, "1 Month Supply" text ke niche note
  
      const addNote = () => {
      if (root.querySelector('[data-onemonth-note]')) return;

      const note = document.createElement('div');
      note.setAttribute('data-onemonth-note', 'true');
      note.textContent = 'Subscription Available for 1 Month Supply Only';

      note.style.cssText = [
        'display: block',
        'margin-top: 0px',
        'margin-bottom: 0px',
        'font-size: 15px',
        'line-height: 1.3',
        'font-weight: 600',
        'color: #000000'
      ].join(';');

      // 1 Month card ke BAAD, subscription box ke BEFORE
      oneMonthCard.insertAdjacentElement('afterend', note);
    };
    addNote();

    let busy = false;

    const setDisabled = (disabled) => {
      const already = subBlock.getAttribute('data-onemonth-disabled') === 'true';
      if (disabled === already) return;

      if (disabled) {
        subBlock.setAttribute('data-onemonth-disabled', 'true');
        subBlock.setAttribute('aria-disabled', 'true');
        subBlock.style.pointerEvents = 'none';
        subBlock.style.opacity = '0.5';
        subBlock.style.cursor = 'not-allowed';
        subBlock.style.filter = 'grayscale(1)';
      } else {
        subBlock.removeAttribute('data-onemonth-disabled');
        subBlock.removeAttribute('aria-disabled');
        subBlock.style.pointerEvents = '';
        subBlock.style.opacity = '';
        subBlock.style.cursor = '';
        subBlock.style.filter = '';
      }
    };

    const update = () => {
      if (busy) return;
      busy = true;
      try {
        addNote(); // agar main script ne card re-render kiya ho to note wapas lagao

        const currentId = String(variantInput.value || '');
        const isOneMonth = currentId === oneMonthId;

        if (isOneMonth) {
          setDisabled(false);
          if (planInput && planInput.disabled) planInput.disabled = false;
          return;
        }

        const subWasSelected = subBlock.classList.contains('is-selected');
        setDisabled(true);

        if (subWasSelected) {
          const currentCard = cards.find(
            (card) => String(card.getAttribute('data-jc-variant-card')) === currentId
          );
          currentCard?.click();
        }

        if (planInput) {
          if (planInput.value !== '') planInput.value = '';
          if (!planInput.disabled) planInput.disabled = true;
        }
      } finally {
        setTimeout(() => { busy = false; }, 50);
      }
    };

    cards.forEach((card) => {
      card.addEventListener('click', () => setTimeout(update, 0));
    });

    subBlock.addEventListener(
      'click',
      (e) => {
        if (subBlock.getAttribute('data-onemonth-disabled') === 'true') {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    const observer = new MutationObserver(() => update());
    cards.forEach((card) =>
      observer.observe(card, { attributes: true, attributeFilter: ['class'] })
    );

    update();
    setTimeout(update, 300);
    setTimeout(update, 1000);
  };

  const start = () => {
    document.querySelectorAll(SCAN_TAGS.join(',')).forEach((el) => {
      const tag = el.tagName.toLowerCase();
      const matchesTag = ALL_PRODUCTS_TAGS.includes(tag);
      const matchesClass = TARGET_CLASSES.some((cls) => el.classList.contains(cls));
      if (matchesTag || matchesClass) init(el);
    });
  };

  const run = () => {
    start();
    setTimeout(start, 500);
    setTimeout(start, 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();